import { environment } from '@coin/shared/core/util-environments';

export const ALL_SELECTABLE_CMS_ITEMS = [
  {
    type: 'image-slider' as const,
    sliderImages: [
      {
        img: 'https://media.istockphoto.com/photos/professionals-in-middle-east-picture-id518084426',
        text: 'Image Slider Headline',
        subtext: 'Image Slider Subtext'
      }
    ]
  },
  {
    type: 'main-body-image-text' as const,
    paddingTop: 10,
    paddingBottom: 10,
    content: {
      img: 'https://media.istockphoto.com/photos/professionals-in-middle-east-picture-id518084426',
      text: 'Main Body Image Text',
      link: ''
    },
    inverted: false
  },
  {
    type: 'index-list' as const,
    paddingTop: 10,
    paddingBottom: 10,
    automaticSyncEnabled: true,
    content: []
  },
  {
    type: 'picture-container' as const,
    pictureContainers: [
      {
        img: 'https://media.istockphoto.com/photos/business-colleagues-walking-towards-the-airplane-picture-id686273518',
        subTitle: 'Picture Container Subtitle',
        mainTitle: 'Picture Container Main Title',
        text: 'Picture Container Text',
        link: ''
      }
    ]
  },
  {
    type: 'compilation' as const,
    collection: {
      left: [
        {
          img: 'https://media.istockphoto.com/photos/tax-form-with-notepad-pen-pencil-and-calculator-picture-id872852194',
          text: 'Compilation Text 1'
        },
        {
          img: 'https://media.istockphoto.com/photos/social-security-files-and-folders-in-desk-drawer-with-labels-and-tabs-picture-id1130578318',
          text: 'Compilation Text 2'
        },
        {
          img: 'https://media.istockphoto.com/photos/close-up-passport-and-map-lay-on-blue-suitcase-at-airporttravel-picture-id836372710',
          text: 'Compilation Text 3'
        }
      ],
      right: {
        top: [
          {
            img: 'https://media.istockphoto.com/photos/making-check-list-for-travel-picture-id1015542074',
            text: 'Compilation Text 4'
          }
        ],
        bottom: {
          left: [
            {
              img: 'https://media.istockphoto.com/photos/business-team-showing-unity-picture-id1155458994',
              text: 'Compilation Text 5'
            },
            {
              img: 'https://media.istockphoto.com/photos/rear-view-of-large-group-of-business-people-raising-arms-on-a-seminar-picture-id1002014170',
              text: 'Compilation Text 6'
            }
          ],
          right: [
            {
              img: 'https://media.istockphoto.com/photos/close-up-stacking-magazine-place-on-table-background-copy-space-picture-id938419492',
              text: 'Compilation Text 7'
            },
            {
              img: 'https://media.istockphoto.com/photos/headset-headphones-telephone-and-laptop-in-call-center-picture-id1033711098',
              text: 'Compilation Text 8'
            }
          ]
        }
      }
    }
  },
  {
    type: 'numbers' as const,
    headline: 'Numbers Headline',
    numbers: [
      {
        topText: 'Numbers Top Text',
        numbers: [1000],
        bottomText: 'Numbers Bottom Text'
      }
    ]
  },
  {
    type: 'spacer' as const,
    height: 50
  },
  {
    type: 'expand-box' as const,
    icon: 'info',
    headline: 'Expandable Headline',
    text: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.'
  },
  {
    type: 'expand-linksbox' as const,
    icon: 'download',
    headline: 'Expand Links Box',
    amountLinks: 2,
    allLinks: [
      {
        text: 'Link Text',
        link: 'https://www.google.de'
      },
      {
        text: 'Link Text 2',
        link: 'https://www.google.de'
      }
    ]
  },
  {
    type: 'line' as const
  },
  {
    type: 'text-block' as const,
    columns: 1,
    headline: 'Text Block Headline',
    text: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.'
  },
  {
    type: 'editor' as const,
    paddingTop: 10,
    paddingBottom: 10,
    isHighlighted: false,
    content:
      '<div>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</div>'
  },
  {
    type: 'bullet-list' as const,
    paddingTop: 10,
    paddingBottom: 10,
    content: '<div><ul><li>Bullet Item 1</li><li>Bullet Item 2</li><li>Bullet Item 3</li></ul></div>'
  },
  {
    type: 'download-file' as const,
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: 11,
    content: [{ text: 'Download Link Text', link: 'https://www.google.de' }]
  },
  {
    type: 'chapter' as const,
    content: { text: 'Chapter Text', icon: 'view_in_ar' }
  },
  {
    type: 'chapter-overview' as const,
    content: [
      { type: 'chapter', content: { text: 'Chapter Text', icon: 'view_in_ar' } },
      { type: 'chapter', content: { text: 'Chapter Text', icon: 'view_in_ar' } },
      { type: 'chapter', content: { text: 'Chapter Text', icon: 'view_in_ar' } },
      {
        type: 'chapter-overview' as const,
        content: [
          { content: { text: 'Chapter Text 1', icon: 'view_in_ar' }, type: 'chapter' },
          { content: { text: 'Chapter Text 2', icon: 'view_in_ar' }, type: 'chapter' },
          { content: { text: 'Chapter Text 3', icon: 'view_in_ar' }, type: 'chapter' }
        ]
      }
    ]
  },
  {
    type: 'cards' as const,
    content: [
      {
        backgroundUrl: 'assets/equity/images/SOG/L.jpg',
        text: 'Card Text',
        headline: 'Card Headline',
        button: { name: 'Button Text', url: 'https://www.google.de' }
      }
    ]
  },
  {
    type: 'email-button' as const,
    paddingTop: 10,
    paddingBottom: 10,
    content: { text: 'Button Text', link: 'https://www.google.de' }
  },
  {
    type: 'email-quote' as const,
    paddingTop: 10,
    paddingBottom: 10,
    content: { text: 'Some Quote Text' }
  },
  {
    type: 'full-width-part-with-image' as const,
    fullWidth: true,
    content: { text: 'Some Text', headline: 'Some Headline', imageUrl: 'assets/equity/images/SOG/SOG-row_en.png' }
  },
  {
    type: 'single-or-multi-image' as const,
    paddingTop: 10,
    paddingBottom: 10,
    content: [{ link: `${environment.coinImagePath}coin/images/originals/coin_email_base_image.png`, anchorLink: '' }]
  },
  {
    type: 'video' as const,
    paddingTop: 10,
    paddingBottom: 10,
    link: ``
  },
  {
    type: 'headline-with-subheadline' as const,
    headline: 'The Siemens Energy share plans',
    text: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.'
  },
  {
    type: 'email-headline' as const,
    paddingTop: 10,
    paddingBottom: 10,
    content: '<div><h2>Email Headline</h2><h4>Email Subheadline</h4></div>'
  },
  {
    type: 'button' as const,
    style: 'primary',
    icon: 'add',
    text: 'Button Text'
  },
  {
    type: 'text-image-link' as const,
    headline: 'Text Image Link Headline',
    text: 'Text Image Link Text',
    buttonText: 'Text Image Link Button Text',
    img: 'https://media.istockphoto.com/photos/future-pilot-picture-id822989228',
    link: 'https://www.siemens.com/global/en.html'
  },
  {
    type: 'email-footnotes' as const,
    content: '<div><p><sup>1</sup>Footnote 1</p><p><sup>2</sup>Footnote 2</p></div>',
    textColor: ''
  }
];
